module.exports = __webpack_public_path__ + "img/company.aa9cfce6.png";